import React, { useState, useEffect, useContext } from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
import logo from "../../assets/imgs/logo.png";
import "./styles.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowRightFromBracket,
  faBars,
} from "@fortawesome/free-solid-svg-icons";
import { Context } from "context/AuthContext";
import { Link } from "react-router-dom";

const Header = () => {
  const [role, setRole] = useState([]);
  const { userData, handleLogout } = useContext(Context);
  const { showLoader } = useContext(Context);

  useEffect(() => {
    const loginUserData = JSON.parse(localStorage.getItem("setstate_quiz"));
    if (loginUserData) {
      setRole(loginUserData.roles);
    }
  }, []);

  async function logout(event) {
    event.preventDefault();
    showLoader(true);
    await handleLogout();
    showLoader(false);
  }

  return (
    <div className="header-horizontal">
      <Navbar expand="lg" className="px-1">
        <Container
          fluid
          className="d-flex align-items-center justify-content-between">
          {/* Logo on the left */}
          <Navbar.Brand
            href="/"
            className="d-flex align-items-end justify-content-end">
            <img src={logo} height="30" alt="Logo" className="header-logo" />
          </Navbar.Brand>

          {/* Toggle button for mobile */}
          <Navbar.Toggle
            aria-controls="basic-navbar-nav"
            className="custom-toggle">
            <FontAwesomeIcon icon={faBars} />
          </Navbar.Toggle>

          {/* Links on the right */}
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto d-flex align-items-center header-nav-links">
              {(role.includes("Admin") || role.includes("Dev")) && (
                <Nav.Link as={Link} to={"/admin"}>
                  Admin
                </Nav.Link>
              )}
              <Nav.Link href="https://aprovese.com.br/">Aprove-se</Nav.Link>
              <Nav.Link onClick={logout} className="d-flex align-items-center">
                Sair
                <FontAwesomeIcon
                  icon={faArrowRightFromBracket}
                  className="ms-2"
                />
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
      {/* Divider */}
      <hr className="header-divider" />
    </div>
  );
};

export default Header;
